'use client';

export default function MemberInfo() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-orange-100">
      <p className="text-orange-600 text-xl"><b>COMING SOON</b></p>
    </div>
  );
}
